module.exports = __webpack_public_path__ + "static/nutrition-mobile-92732037112055b6135eea723e17cdc4.svg";